export function howWorkSlider() {
    let sliderParent = $(".how-work-slider");
    let contentSlider = sliderParent.find(".how-work-content");
    let pictureSlider = sliderParent.find(".how-work-pictures");

    pictureSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: $(contentSlider)[0]
    });

    contentSlider.on('init', function(event, slick){
        let slideThumb = contentSlider.find(".how-work-content-item");
        slideThumb.each((index, item) => {
            $(item).prepend(`<span class="number">${index + 1}</span>`);
        });
    });
    contentSlider.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        mobileFirst: true,  
        asNavFor: $(pictureSlider)[0],
        focusOnSelect: true,
        fade: true,
        dots: true,
        appendArrows: $(sliderParent).find(".navigation-box"),
        appendDots: $(sliderParent).find(".navigation-box"),
        // customPaging: function(slick,index) {
        //     return '<button type="button" data-role="none" role="button" tabindex="0">' + (index + 1) + '</button>';
        // }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/how-work-slider.js